import { authGuard } from '@/shared/guards/auth.guard';
import { notAuthGuard } from '@/shared/guards/not-auth.guard';
import { permissionsGuard } from '@/shared/guards/permissions.guard';
import { Routes } from '@angular/router';

export const appRoutes: Routes = [
    {
        path: '',
        loadComponent: () => import('@/auth/auth.component').then((m) => m.AuthComponent),
        loadChildren: () => import('@/auth/auth.routes').then((m) => m.default),
        canActivate: [authGuard]
    },
    {
        path: 's',
        loadComponent: () => import('@/main/main.component').then((m) => m.MainComponent),
        children: [
            {
                path: 'home',
                title: 'Inicio | Palta - Backoffice',
                data: { breadcrumb: 'Inicio' },
                loadComponent: () => import('@/main/pages/home/home.component').then((m) => m.HomeComponent),
                loadChildren: () => import('@/main/pages/home/home.routes').then((m) => m.default)
            },
            {
                path: 'user',
                data: { breadcrumb: 'Clientes' },
                children: [
                    {
                        path: '',
                        title: 'Clientes | Palta - Backoffice',
                        loadComponent: () => import('@/main/pages/users/users.component').then((m) => m.UsersComponent)
                    },
                    {
                        path: 'add',
                        title: 'Agregar cliente | Palta - Backoffice',
                        data: { breadcrumb: 'Agregar Cliente' },
                        loadComponent: () => import('@/main/pages/users/add/add.component').then((m) => m.AddComponent)
                    },
                    {
                        path: 'add/business',
                        title: 'Agregar cuenta empresa | Palta - Backoffice',
                        data: { breadcrumb: 'Agregar cuenta empresa' },
                        loadComponent: () => import('@/main/pages/users/add/business/business.component').then((m) => m.BusinessComponent)
                    },
                    {
                        path: 'detail/:userId',
                        title: 'Ver Cliente | Palta - Backoffice',
                        data: { breadcrumb: 'Ver Cliente' },
                        loadComponent: () => import('@/main/pages/users/view/view.component').then((m) => m.ViewComponent),
                        loadChildren: () => import('@/main/pages/users/view/view.routes').then((m) => m.default)
                    }
                ]
            },

            // {
            //     path: 'roles', data: { breadcrumb: 'Roles' }, children: [
            //         { path: '', title: 'Roles | Palta - Backoffice', loadComponent: () => import('@/main/pages/roles/roles.component').then(m => m.RolesComponent) },
            //         { path: 'addedit', title: 'Agregar Rol | Palta - Backoffice', data: { breadcrumb: 'Asignar permisos y usuarios al rol' }, loadComponent: () => import('@/main/pages/roles/add-edit-roles/add-edit-roles.component').then(m => m.AddEditRolesComponent) }]
            // },
            // { path: 'cash', title: 'Caja | Palta - Backoffice', data: { breadcrumb: 'Caja' }, loadComponent: () => import('@/main/pages/cash-register/cash-register.component').then(m => m.CashRegisterComponent) },
            // {
            //     path: 'cards', data: { breadcrumb: 'Tarjetas' }, children: [
            //         { path: '', title: 'Tarjetas | Palta - Backoffice', loadComponent: () => import('@/main/pages/cards/cards.component').then(m => m.CardsComponent) },
            //         { path: 'add', title: 'Nueva Tarjeta | Palta - Backoffice', data: { breadcrumb: 'Nueva Tarjeta' }, loadComponent: () => import('@/main/pages/cards/add-card/add-card.component').then(m => m.AddCardComponent) },
            //         { path: 'edit/:cardId', title: 'Editar Tarjeta | Palta - Backoffice', data: { breadcrumb: 'Editar Tarjeta' }, loadComponent: () => import('@/main/pages/cards/add-card/add-card.component').then(m => m.AddCardComponent) },
            //         { path: ':cardId/user', title: 'Información de Tarjeta | Palta - Backoffice', data: { breadcrumb: 'Información de tarjeta' }, loadComponent: () => import('@/main/pages/cards/usercards/usercards.component').then(m => m.UsercardsComponent) }
            //     ]
            // },
            // {
            //     path: 'banners', data: { breadcrumb: 'Banners' }, children: [
            //         { path: '', title: 'Banners | Palta - Backoffice', loadComponent: () => import('@/main/pages/banners/banners.component').then(m => m.BannersComponent) },
            //         { path: 'add', title: 'Crear banner | Palta - Backoffice', data: { breadcrumb: 'Crear banner' }, loadComponent: () => import('@/main/pages/banners/add-banner/add-banner.component').then(m => m.AddBannerComponent) },
            //         { path: 'edit/:id', title: 'Editar banner | Palta - Backoffice', data: { breadcrumb: 'Editar banner' }, loadComponent: () => import('@/main/pages/banners/add-banner/add-banner.component').then(m => m.AddBannerComponent) },
            //         { path: 'configuration', title: 'Configuración | Palta - Backoffice', data: { breadcrumb: 'Configuración' }, loadComponent: () => import('@/main/pages/banners/configuration/configuration.component').then(m => m.ConfigurationComponent) }
            //     ]
            // },
            { path: 'alerts', title: 'Alertas | Palta - Backoffice', data: { breadcrumb: 'Alertas' }, loadComponent: () => import('@/main/pages/alerts/alerts.component').then((m) => m.AlertsComponent) },
            { path: 'adjustments', title: 'Tipos de ajuste | Palta - Backoffice', data: { breadcrumb: 'Tipos de ajuste' }, loadComponent: () => import('@/main/pages/adjustments/adjustments.component').then((m) => m.AdjustmentsComponent) },

            {
                path: 'administration',
                data: { breadcrumb: 'Administración' },
                children: [
                    {
                        path: 'admin-roles',
                        title: 'Administración de usuarios y roles | Palta - Backoffice',
                        data: { breadcrumb: 'Usuarios' },
                        loadComponent: () => import('@/main/pages/administration/admin-users-roles/admin-users-roles.component').then((m) => m.AdminUsersRolesComponent),
                        loadChildren: () => import('@/main/pages/administration/admin-users-roles/adminUser-roles.routes').then((m) => m.default)
                    },
                    {
                        path: 'segments',
                        data: { breadcrumb: 'Segmentación' },
                        children: [
                            { path: '', title: 'Segmentación | Palta - Backoffice', data: { breadcrumb: 'Segmentación' }, loadComponent: () => import('@/main/pages/administration/segments/segments.component').then((m) => m.SegmentsComponent) },
                            {
                                path: ':id/users',
                                title: 'Asignar cuentas | Palta - Backoffice',
                                data: { breadcrumb: 'Asignar cuentas' },
                                loadComponent: () => import('@/main/pages/administration/segments/users/users.component').then((m) => m.UsersComponent)
                            }
                        ]
                    },

                    {
                        path: 'commissions',
                        data: { breadcrumb: 'Comisiones' },
                        children: [
                            { path: '', title: 'Comisiones | Palta - Backoffice', loadComponent: () => import('@/main/pages/administration/commissions/commissions.component').then((m) => m.CommissionsComponent) },

                            {
                                path: 'commission',
                                title: 'Crear comisión | Palta - Backoffice',
                                data: { breadcrumb: 'Crear comisión' },
                                loadComponent: () => import('@/main/pages/administration/commissions/commission/commission.component').then((m) => m.CommissionComponent)
                            },

                            {
                                path: 'commission/:id',
                                title: 'Editar comisión | Palta - Backoffice',
                                data: { breadcrumb: 'Editar comisión' },
                                loadComponent: () => import('@/main/pages/administration/commissions/commission/commission.component').then((m) => m.CommissionComponent)
                            },

                            {
                                path: 'excluded/:commissionId',
                                title: 'Comisiones excluidas | Palta - Backoffice',
                                data: { breadcrumb: 'Comisiones excluidas' },
                                loadComponent: () => import('@/main/pages/administration/commissions/excluded/excluded.component').then((m) => m.ExcludedComponent)
                            }
                        ]
                    },
                    {
                        path: 'taxes',
                        data: { breadcrumb: 'Impuestos' },
                        children: [
                            {
                                path: '',
                                title: 'Impuestos | Palta - Backoffice',
                                loadComponent: () => import('@/main/pages/administration/taxes/taxes.component').then((m) => m.TaxesComponent)
                            },
                            {
                                path: 'tax',
                                title: 'Crear impuesto | Palta - Backoffice',
                                data: { breadcrumb: 'Crear impuesto' },
                                loadComponent: () => import('@/main/pages/administration/taxes/tax/tax.component').then((m) => m.TaxComponent)
                            },
                            {
                                path: 'tax/:id',
                                title: 'Editar impuesto | Palta - Backoffice',
                                data: { breadcrumb: 'Editar impuesto' },
                                loadComponent: () => import('@/main/pages/administration/taxes/tax/tax.component').then((m) => m.TaxComponent)
                            },
                            {
                                path: 'excluded/:commissionId',
                                title: 'Personas excluidas | Palta - Backoffice',
                                data: { breadcrumb: 'Asignar usuarios' },
                                loadComponent: () => import('@/main/pages/administration/taxes/excluded/excluded.component').then((m) => m.ExcludedComponent)
                            }
                        ]
                    },
                    {
                        path: 'commission-account',
                        data: { breadcrumb: 'Cuenta de comisiones' },
                        children: [
                            {
                                path: '',
                                title: 'Cuenta de comisiones | Palta - Backoffice',
                                loadComponent: () => import('@/main/pages/administration/commission-account/commission-account.component').then((m) => m.CommissionAccountComponent)
                            }
                        ]
                    }
                ]
            },
            {
                path: 'verification-scores',
                title: 'Scores de verificación | Palta - Backoffice',
                data: { breadcrumb: 'Scores de verificación' },
                loadComponent: () => import('@/main/pages/verification-scores/verification-scores.component').then((m) => m.VerificationScoresComponent)
            },
            { path: 'movements', title: 'Movimientos | Palta - Backoffice', data: { breadcrumb: 'Movimientos' }, loadComponent: () => import('@/main/pages/movements/movements.component').then(m => m.MovementsComponent) },
            { path: 'companies', title: 'Empresas | Palta - Backoffice', data: { breadcrumb: 'Empresas' }, loadComponent: () => import('@/main/pages/companies/companies.component').then(m => m.CompaniesComponent) },
            { path: 'reports', title: 'Reportes | Palta - Backoffice', data: { breadcrumb: 'Reportes' }, loadComponent: () => import('@/main/pages/reports/reports.component').then((m) => m.ReportsComponent) },
            {
                path: 'accounts',
                data: { breadcrumb: 'Cuentas' },
                children: [
                    {
                        path: '',
                        title: 'Cuentas | Palta - Backoffice',
                        loadComponent: () =>
                            import('@/main/pages/accounts/accounts.component').then((m) => m.AccountsComponent)
                    },
                    {
                        path: ':accountId',
                        title: 'Datos de la cuenta | Palta - Backoffice',
                        data: { breadcrumb: 'Datos de la cuenta' },
                        loadComponent: () =>
                            import('@/main/pages/accounts/account/account.component').then((m) => m.AccountComponent),
                        loadChildren: () => import('@/main/pages/accounts/account/account.routes').then((m) => m.default)
                    }
                ]
            },
            { path: '', redirectTo: 'home', pathMatch: 'full' },
        ],
        canActivate: [notAuthGuard]
    }
];
